import {getIntegrations} from "../api/integrations";
import {editAddIntegration, deleteIntegration} from "../api/integrations";
import {getIntegrationsFromCookies} from "../utilis/integration_cookies";
import store from '../store'
import mixins from '../mixins'
import router from '../router'
export default{
    store,
    router,
    mixins: [mixins],
    data:() => {
        return {
            editedAddIntegration:{},
            userIntegrations: null,
            loading: false,
            initialized: false
        }
    },
    computed:{
        activeIntegration(){
            if(this.$route.params.type) return this.types.find(x => x.type == this.$route.params.type);
            if(this.$route.params.id && this.editedAddIntegration) return this.types.find(x => x.type == this.editedAddIntegration.type);
            return null
        },
        connectedIntegrations(){
            var arr = [];
            for(var i in this.userIntegrations){
                if(this.userIntegrations[i]){
                    arr.push({type:i, ...this.userIntegrations[i], typeObject: this.types.find(x => x.type == i)});
                }
            }
            return arr;
        },
        types(){
            return [
                {
                    name: 'Shopify',
                    type: 'shopify',
                    logo: '/default/drop/shopify_logo.png',
                    image: '/default/shopify_image.png',
                    short_description: 'Integrate Drop with Shopify',
                    long_description: 'Quite short description what can you do after integration',
                    help_description: 'Enter your shopify store URL to integrate drop with shopify. You cannot change this URL later, so take care if it’s correct',
                    new_integration_description: 'Your shop data has been prefilled. Please check if the shop domain is correct and click <span style="font-weight: bold;">Connect</span>',                    connect_redirect: 'https://shopofy',
                    connectInstruction: '1. Go to your <a href="https://shopify.com" target="_blank"> shopify </a> store <br>' +
                        '2. Connect <strong>Drop</strong> application to your shopify store. <br>' +
                        '3. You will be automatically redirected to the <strong>DROP</strong> application. <br>' +
                        '4. The integrated shopify store will appear in the list of integrated stores. <br>',
                    edit_add_bottom_text: 'You don’t have your own store on shopify yet? Create store on <a href="https://shopify.com" target="_blank">shopify.com</a>',
                    fields:[
                        {
                            type: 'text',
                            key: 'domain',
                            label: 'Domain',
                            help: 'Help text',
                            rules:[this.validationRules.required]
                        },
                        {
                            type: 'password',
                            key: 'api_key',
                            label: 'Api key',
                            rules:[this.validationRules.required]
                        },
                    ]
                }
            ]
        }
    },
    methods:{
        init(){
            return new Promise((resolve,reject) => {
                Promise.all([this.getUserIntegrations()]).then(res => {
                    resolve();
                });
            })
        },
        getUserIntegrations(){
            return new Promise((resolve, reject) => {
                this.loading = true;
                getIntegrations().then(res => {
                    this.userIntegrations = res;
                    var findedIntegration = null;
                    if(this.$route.params.type && (findedIntegration = this.connectedIntegrations.find(x => x.type == this.$route.params.type))){
                        this.editedAddIntegration = Object.assign({}, findedIntegration);
                    }
                    if(this.$route.params.id && (findedIntegration = this.connectedIntegrations.find(x => x.id == this.$route.params.id))){
                        this.editedAddIntegration = Object.assign({}, findedIntegration);
                    }
                    this.loading = false;
                    this.initialized = true;
                    resolve();
                }).catch(e => {
                    this.loading = false;
                    this.initialized = true;
                    this.$store.commit('app/ADD_MESSAGE', {text: 'Cant fetch integrations.'+' '+e.response.data.message, type: 'error'});
                    reject();
                })
            })
        },
        saveIntegration(){
            return new Promise((resolve, reject) => {
                this.loading = true;
                editAddIntegration({type: this.activeIntegration.type, ...this.editedAddIntegration}, this.editedAddIntegration.id).then(res => {
                    this.loading = false;
                    resolve();
                }).catch(e => {
                    this.loading = false;

                    this.$store.commit('app/ADD_MESSAGE', {text: 'Cant save integration.'+' '+e.response.data.message, type: 'error'});
                    reject();
                })
            })
        },
        deleteIntegration(){
            return new Promise((resolve, reject) => {
                this.loading = true;
                deleteIntegration(this.editedAddIntegration.id, this.editedAddIntegration.type).then(res => {
                    resolve();
                    this.loading = false;
                }).catch(e => {
                    this.$store.commit('app/ADD_MESSAGE', {text: "Can't delete integration. "+e.response.data.message, type:'error'});
                    this.loading = false;
                    reject();
                })
            })
        }
    }
}

